<template>
  <div class="dashboard_container instructor_db" aria-label="Instructor Dashboard Page Content">

    <div class="row">
      <div class="col-12 dashboard-content-section">

        <template v-if="advisees.total === 0">
          <div class="row">
            <div class="col-xl-8 col-lg-7 col-md-12 col-sm-12 pr-0">
              <b-col cols="12 pl-0 pr-0 pg-lft-col">
                <b-row class="dashboard-row">
                  <b-col cols="12">
                    <div class="card ace_sec" aria-label="All Courses Section">
                      <div class="card-header">
                        <b-link @click="navigateToMyCourses()">
                          <span class="icon float-left icon-course text-center mr-2"></span>
                          <span class="label ace_sec_hd" role="heading" aria-lavel="1">
                            {{ $tf('allCourses') }}
                          </span>
                        </b-link>
                      </div>
                      <div class="card-body carousel slide">
                        <div class="carousel-inner">
                          <button class="button-primary fa fa-angle-left float-left" :disabled="page === 0" @click="prev" aria-label="previous"></button>
                          <div class="item active">
                            <template v-for="course in courses">
                              <b-button class="course course_btn ace_sec_txt" @click="navigateToCourseDashboard(course.uuid)" :title="course.title">
                                <div class="course_name_1" :title="course.title" :aria-label="course.title">
                                  <v-clamp class="title_txt" autoresize :max-lines="3">{{ course.title }}</v-clamp>
                                </div>
                                <div class="thumbnail_container">
                                  <div class="icon-course">
                                    <div class="icon-master" v-if="course.master">m</div>
                                  </div>
                                </div>
                              </b-button>
                            </template>
                          </div>
                          <button class="button-primary fa fa-angle-right float-right" :disabled="lastPage === true" @click="next" aria-label="next"></button>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="dashboard-row btm-sec">
                  <b-col cols="12">
                    <div class="card ace_sec" aria-label="$tf('quickLinksSection')">
                      <div class="card-header">
                        <span class="icon float-left icon-link text-center mr-2"></span>
                        <span class="label ace_sec_hd" role="heading" aria-lavel="1">
                          {{ $tf('quickLinks') }}
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="card-content v_scroll">
                          <div class="quick_link">
                            <ul role="list">
                              <li v-for="quickLink in quickLinks">
                                <a :href="quickLink.url" target="_blank"  :aria-label="'Link to ' + quickLink.title" role="link">
                                  {{ quickLink.title }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <div class="col-xl-4 col-lg-5 col-md-12 col-sm-12">
              <b-col cols="12" class="pr-0 pg-rgt-col">
                <b-row class="dashboard-row">
                  <b-col cols="12 pr-0">
                    <div class="card ace_sec" aria-label="$tf('recommendationsSection')">
                      <div class="card-header">
                        <span class="icon float-left icon-bullhorn text-center mr-2"></span>
                        <span class="label ace_sec_hd" role="heading" aria-lavel="1">
                          {{ $tf('recommendations') }}
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="card-content v_scroll">
                          <div class="recommendations">
                            <div class="coming_soon ace_sec_txt">Coming Soon</div>
                            <!--
                            <div class="row">
                            	<div class="profile_pic">
                            		<span class="icon icon-admin"></span>
                            	</div>
                            	<div class="details">
                            		<div class="tp_row">
                            			<div class="title">Administrator</div>
                            			<div class="time">7:23 PM</div>
                            		</div>
                            		<div class="btm_row">
                            			Internship at Qualcom
                            		</div>
                            	</div>
                            </div>

                            <div class="row">
                            	<div class="profile_pic">
                            		<span class="icon icon-user"></span>
                            	</div>
                            	<div class="details">
                            		<div class="tp_row">
                            			<div class="title">Prof. Whitman</div>
                            			<div class="time">7:43 PM</div>
                            		</div>
                            		<div class="btm_row">
                            			Internship at Illumina. There is only one space left.
                            		</div>
                            	</div>
                            </div>

                            <div class="row">
                            	<div class="profile_pic">
                            		<span class="icon icon-user"></span>
                            	</div>
                            	<div class="details">
                            		<div class="tp_row">
                            			<div class="title">Prof. Kandinsky</div>
                            			<div class="time">6:18 PM</div>
                            		</div>
                            		<div class="btm_row">
                            			Veterna’s Center talk
                            		</div>
                            	</div>
                            </div>
                            -->
                            <!-- row end -->
                          </div>
                          <!-- recommendations end -->
                        </div>
                        <!-- card-content end -->
                      </div>
                      <!-- card-body end -->
                    </div>
                    <!-- card end -->
                  </b-col>
                </b-row>
                <!-- dashboard-row end -->
              </b-col>
            </div>
          </div>
        </template>

        <template v-if="advisees.total > 0">
          <div class="row">
            <div class="col-xl-8 col-lg-7 col-md-12 col-sm-12">
              <b-col cols="12 pl-0 pr-0 pg-lft-col">
                <b-row class="dashboard-row">
                  <b-col cols="12">
                    <div class="card ace_sec" aria-label="All Courses Section">
                      <div class="card-header">
                        <b-link @click="navigateToMyCourses()">
                          <span class="icon float-left icon-course text-center mr-2"></span>
                          <span class="label ace_sec_hd" role="heading" aria-lavel="1">All Courses</span>
                        </b-link>
                      </div>
                      <div class="card-body carousel slide">
                        <div class="carousel-inner">
                          <button class="button-primary fa fa-angle-left float-left" :disabled="page === 0" @click="prev" aria-label="previous"></button>
                          <div class="item active">
                            <template v-for="course in courses">
                              <div class="course ace_sec_txt" @click="navigateToCourseDashboard(course.uuid)" :title="course.title">
                                <div class="course_name" :title="course.title" :aria-label="course.title">
                                  <v-clamp class="title_txt" autoresize :max-lines="3">{{ course.title }}</v-clamp>
                                </div>
                                <div class="thumbnail_container">
                                  <div class="icon-course">
                                    <div class="icon-master" v-if="course.master">m</div>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                          <button class="button-primary fa fa-angle-right float-right" :disabled="lastPage === true" @click="next" aria-label="next"></button>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <div class="col-xl-4 col-lg-5 col-md-12 col-sm-12">
              <b-row class="dashboard-row btm-sec">
                <b-col cols="12">
                  <div class="card ace_sec" aria-label="Quick Links Section">
                    <div class="card-header">
                      <span class="icon float-left icon-link text-center mr-2"></span>
                      <span class="label ace_sec_hd" role="heading" aria-lavel="1">
                        {{ $t('quickLinks') }}
                      </span>
                    </div>
                    <div class="card-body">
                      <div class="card-content v_scroll">
                        <div class="quick_link">
                          <ul role="list">
                            <li v-for="quickLink in quickLinks">
                              <a
                                :href="quickLink.url"
                                target="_blank"
                                :aria-label="$t('linkTo') + ' ' + quickLink.title"
                                role="link">
                                  {{ quickLink.title }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>

          <div class="row instructor_db_row">
            <div class="col-12 dashboard-content-section">
              <advisee-tracker></advisee-tracker>
            </div>
          </div>
        </template>

      </div>
    </div>

  </div>
</template>

<script>
  import '../../../assets/module/css/dashboard/dashboard.min.css'
  import { mapState, mapActions } from 'vuex'
  import AdviseeTracker from '../../adviseeTracker/components/./AdviseeTracker'
	import VClamp from 'vue-clamp'
  var staticQuickLinks = function () {
    var quickLinks = []
    return quickLinks
  }

  export default {
    name: 'instructor-dashboard',
    components: {
      AdviseeTracker,
			VClamp
    },
    props: [],
    data: () => {
      return {
        page: 0,
        courses: [],
        lastPage: false,
        advisees: {total: 0},
        quickLinks: []
      }
    },

    async mounted () {
      this.advisees = await this.loadAdvisees({name: ''})
      this.loadQuickLinks('QUICKLINK').then(res => {
        const quickLinks = (this.links.length > 0) ? this.links : staticQuickLinks()
        $.each(quickLinks, (index, quickLink) => {
          this.quickLinks.push(quickLink)
        })
      })
      this.populateEnrolledCourses()
      window.addEventListener('resize', this.handleWindowResize)
    },

    methods: {
      ...mapActions([
        'loadQuickLinks',
        'loadEnrolledCourses',
        'loadAdvisees'
      ]),

      handleWindowResize (event) {
        let routeName = this.$router.currentRoute.name
        if (routeName === 'instructorDashboard') {
          this.populateEnrolledCourses()
        }
      },

      populateEnrolledCourses () {
        var itemCount
        if ($(window).width() < 1501) {
          itemCount = 2
        } else {
          itemCount = 3
        }
        const pagingOptions = {page: this.page, count: itemCount}
        this.loadEnrolledCourses(pagingOptions).then(res => {
          if (res && res.length > 0) {
            this.courses = res
            if (res.length < this.count) {
              this.lastPage = true
            }
          } else {
            if (this.page > 0) {
              this.page -= 1
            }
            this.lastPage = true
          }
        })
      },

      beforeDestroy: function () {
        window.removeEventListener('resize', this.handleWindowResize)
      },

      prev () {
        if (this.page > 0) {
          this.page -= 1
          this.populateEnrolledCourses()
        }

        if (this.lastPage) {
          this.lastPage = false
        }
      },

      next () {
        if (!this.lastPage) {
          this.page += 1
          this.populateEnrolledCourses()
        }
      },
      navigateToMyCourses() {
          return this.$router.push({name: 'myCourseSections'})
      },
      navigateToCourseDashboard (uuid) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        return this.$router.push({name: 'courseDashboardInstructor', params: { uuid: uuid }})
      }
    },
    computed: {
      ...mapState({
        'links': state => state.dashboard.quickLinks
      })
    }
  }
</script>

<style scoped>
    .next {
        margin-top: 10%;
    }

    .icon-master {
        float: right !important;
        margin-top: 0px !important;
        margin-left: 0px !important;
    }
		.instructor_db_row .dashboard-content-section .dashboard_container {
			margin-left: 0px;
			padding: 0px;
			width: 100%;
		}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/InstructorDashboard.vue